<template>
  <div class="storedetailApp" :style="'min-height:'+curHeight+'px'" v-loading.fullscreen.lock="fullscreenLoading" element-loading-text="数据加载中" element-loading-background="rgba(0, 0, 0, 0)" element-loading-spinner="el-icon-loading">
    <swiper :options="swiperOption">
      <swiper-slide class="swiper-slide games">
        <div class="fmt" :style="'background:url('+baseUrl+detail.image+') no-repeat left center;background-size:100%'"></div>
        <!--<img :src="baseUrl+detail.image">-->
      </swiper-slide>
      <div class="swiper-pagination" slot="pagination"></div>
    </swiper>

    <div class='choose'>
      <div class="biaoti">
        <span class="price"><i><b>¥</b> {{detail.rate}}</i></span>
        <span class="yjPrice">￥{{detail.price}}</span>
        <span v-if="detail.deposit > 0 && detail.rate > 0" style="color:#f00;font-size:14px;padding-left:15px">包含￥{{detail.deposit}}押金</span>
        <div class="aaa">{{detail.title}}</div>
        <div class="breif">分类:{{detail.cname}}</div>
        <div class="breif">库存:{{detail.stock - detail.use}}件</div>
      </div>
      <div v-if="detail.rate > 0">
      <div class="chooseUser" v-if="attest.length <= 0" @click="go">
        <div class="leftuser">
          <p>选择人员</p>
        </div>
        <img src="~assets/images/me_jiantou.png" />
      </div>
      <div class="chooseUser" v-if="attest.length > 0">
        <div class="leftuser" @click="drawer = true">
          <p>{{name}}</p>
          <p class="curt" v-if="idCard !=''">{{idCard}}</p>
        </div>
        <img src="~assets/images/me_jiantou.png" />
      </div>
      </div>

      <div v-if="detail.rate <= 0">
      <div class="chooseUser" >
        <div class="leftuser">
          <p>{{detail.arr.name}}</p>
          <p class="curt">{{detail.arr.phone}}</p>
        </div>
        <img src="~assets/images/me_jiantou.png" />
      </div>
      </div>


      <div class="mscon" v-html="detail.content"></div>
    </div>   
    <div style="height:80px;"></div>
    <div class="footer1">
      <div class="foot-title">
        <span>1件</span>
        <span>
          <i>￥</i><b>{{detail.rate}}</b>
        </span>
      </div>
      <div class="pay" @click="storePay" v-if="detail.rate > 0 && detail.stock > detail.use">
        <span>立即购买</span>        
      </div>
      <div class="pay" @click="storeOut" v-if="detail.rate <= 0 && detail.stock > detail.use">
        <span>立即租用</span>        
      </div>

      <div class="pay" v-if="detail.stock <= detail.use">
        <span style="background:#ebebeb">已售空</span>        
      </div>
    </div>


    <el-drawer
      title="选择人员" :visible.sync="drawer" :direction="direction" size="50%" :withHeader="true">
      <ul>
        <li v-for="(item,i) in attest" @click="choose(i)">
          <p>{{item.name}}</p>
          <p>{{item.card}}</p>
          <a v-if="i==active"><img src="~assets/images/choose2.png" /></a>
          <a v-if="i!=active"><img src="~assets/images/choose1.png" /></a>
        </li>
      </ul>
      <a class="append" @click="go">追加人员</a>
    </el-drawer>
    
  </div>
</template>

<script>
  export default {
    data() {
      return {
        swiperOption: {
          autoplay : {
            disableOnInteraction: false, //用户操作后是否禁止自动循环
            delay: 3000 //自自动循环时间
          }, //可选选项，自动滑动
          speed: 1000, //切换速度，即slider自动滑动开始到结束的时间（单位ms）
          loop:true, //循环切换
          grabCursor: true, //设置为true时，鼠标覆盖Swiper时指针会变成手掌形状，拖动时指针会变成抓手形状
          autoHeight: true,   //自动高度。设置为true时，wrapper和container会随着当前slide的高度而发生变化。   
          scrollbar: '.swiper-scrollbar',
          mousewheelControl: true, //设置为true时，能使用鼠标滚轮控制slide滑动
          observeParents: true, //当改变swiper的样式（例如隐藏/显示）或者修改swiper的子元素时，自动初始化swiper
       
          pagination: {
            el: '.swiper-pagination',
            clickable :true, //点击分页器的指示点分页器会控制Swiper切换
          },  
        },
        curHeight:0,
        fullscreenLoading: false,
        baseUrl:'',
        detail:[],
        num:1,
        userData:[],
        code:'',
        drawer:false,
        direction: 'btt',
        attest:[],
        name:'选择购买人员',
        idCard:'',
        active:''
      };
    },
    beforeMount() {
      this.baseUrl = this.$host;
      document.addEventListener('WeixinJSBridgeReady', function onBridgeReady() {
          WeixinJSBridge.call('hideOptionMenu');
      });

      var id = this.$route.query.id;
      if(localStorage.getItem('userjwt') == null){
        var code = this.codefun('code');
        if(!code){
          var url = encodeURIComponent('http://user.4008005216.com/main/storeDetail?id='+id);
          window.location.href = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxa89a20966e69c2a5&redirect_uri="+url+"&response_type=code&scope=snsapi_userinfo&state=STATE";
          return;
        }else{
          this.code = code;
          this.login();
        }
      }
    },
    created(){
      this.userData = localStorage.getItem('userjwt') == null ? [] : JSON.parse(localStorage.getItem('userjwt'));
    },
    mounted() {
      this.beforeMount();
      this.getDetail();
      this.attest1();
    },

    methods: {
      beforeMount:function(){
        var h = document.documentElement.clientHeight || document.body.clientHeight;
        this.curHeight =h; //减去页面上固定高度height
      },
      go:function(){
        window.location.href="http://user.4008005216.com/main/attest"
      },

      choose:function(n){
        this.active = n;
        this.idCard = this.attest[n].card;
        this.name = this.attest[n].name;
        this.drawer = false;
      },

      attest1:function(){
        var that = this;
        that.fullscreenLoading = true
        this.axios({
          method:'post',
          url:that.$host+'home/user/attest',
          params:{
            user_id:that.userData.id
          }
        }).then(function(response){
          var res = response.data.data;
          that.attest = res.rs;
          that.phone = res.phone.phone;
          that.fullscreenLoading = false;
        }).catch(err=>{
          that.fullscreenLoading = false
        });
      },

      storeOut:function(){
        var that = this;
        var id = this.detail.id;
        that.axios({
          method:'post',
          url:that.$host+'home/store/outPay',
          params:{
            id:id,
            store_id:that.detail.store_id,
            user_id:that.userData.id,
            phone:that.detail.arr.phone,
            name:that.detail.arr.name,
            idCard:'',
            price:that.detail.rate,
          }
        }).then(function(response){
          var res = response.data.data;
          if(response.data.status == 200){
            window.location.href="http://user.4008005216.com/main/storeOrder?id=1";
          }else{
            alert(response.data.message);
          }
        }).catch(err=>{
          console.log('请求失败:'+err);
          that.fullscreenLoading = false
        });
      },

      storePay:function(){
        var that = this;
        if(that.idCard == ''){
          that.$alert('选择购买人员!', '提示', {
            confirmButtonText: '确定'
          });
          return false;
        }
        var id = this.detail.id;

        that.axios({
          method:'post',
          url:that.$host+'home/store/weixinPay',
          params:{
            id:id,
            store_id:that.detail.store_id,
            user_id:that.userData.id,
            phone:'',
            name:that.name,
            idCard:that.idCard,
            price:that.detail.rate,
          }
        }).then(function(response){
          var res = response.data.data;
          if(response.data.status == 200){
            that.callpay(res);
          }else{
            alert('支付失败');
          }
        }).catch(err=>{
          console.log('请求失败:'+err);
          that.fullscreenLoading = false
        });
      },
      jsApiCall:function(msg){
        var that = this;
          WeixinJSBridge.invoke(
              'getBrandWCPayRequest',
              {
                "appId":'wxa89a20966e69c2a5',
                "timeStamp":msg.timeStamp,         //时间戳，自1970年以来的秒数     
                "nonceStr":msg.nonceStr, //随机串     
                "package":msg.package,     
                "signType":msg.signType,         //微信签名方式：     
                "paySign":msg.paySign 
              },
              function(res){
                  if(res.err_msg == "get_brand_wcpay_request:ok"){
                    window.location.href="http://user.4008005216.com/main/storeOrder?id=1";
                  }else{
                     //返回跳转到订单详情页面
                      alert('支付失败');return false
                  }
              }
          );
      },

      callpay:function(data){
        if (typeof WeixinJSBridge == "undefined"){
          if( document.addEventListener ){
              document.addEventListener('WeixinJSBridgeReady', jsApiCall, false);
          }else if (document.attachEvent){
              document.attachEvent('WeixinJSBridgeReady', jsApiCall); 
              document.attachEvent('onWeixinJSBridgeReady', jsApiCall);
          }
        }else{
          this.jsApiCall(data);
        }
      },

      getDetail:function(){
        var that = this;
        var id = this.$route.query.id;
        that.fullscreenLoading = true
        this.axios({
          method:'post',
          url:that.$host+'home/store/detail',
          params:{
            id:id,
            user_id:that.userData.id
          }
        }).then(function(response){
          var res = response.data.data;
          that.detail = res;
          that.fullscreenLoading = false
        }).catch(err=>{
          console.log('请求失败:'+err);
          that.fullscreenLoading = false
        });
      },
      login:function(){
        var that = this;
        that.axios({
          method:'post',
          url:that.$host+'home/user/login',
          params:{
            code:that.code
          }
        }).then(function(response){
          var res = response.data;
          that.userData = res.data;
          localStorage.setItem('userjwt', JSON.stringify(res.data));
        }).catch(err=>{

        });
      },
      codefun:function(name) {
        let reg = new RegExp("(\\?|&)" + name + "=([^&]*)(&|$)", "i");
        let r = window.location.search.match(reg);
        if (r != null) return unescape(r[2]);
        return false;
      }
    },
  };
</script>

<style>
  .el-loading-spinner{
    width:30%;
    background:rgba(0,0,0,0.8);
    left:50%;
    transform: translateX(-50%);
    border-radius:5px;
    padding:15px 0;
    color:#fff;
  }
  .el-loading-spinner i{
    color:#fff;
    font-size:22px
  }
  .el-loading-spinner .el-loading-text{
    color:#fff;
  }
  .el-message-box{
    width:70%
  }
  .storedetailApp{
    max-width:640px;
    background:#f7faff;
    margin:0 auto;
  }
  .storedetailApp .games .fmt{
    display:block;
    width:100%;
    height:240px
  }
  .choose{ 
    width:94%; 
    display:block;
    margin:0 auto;
  }
  .choose .biaoti{
    margin-bottom: 15px;
    padding: 15px 4%;
    position: relative;
    background: #FFFFFF;
    box-shadow: 0px 0px 10px 0px rgba(47, 120, 255, 0.2);
    border-radius: 10px;
    margin-top:15px;
  }
  .choose .biaoti .aaa{
    display: block;
    font-size: 16px;
    color: #333;
    font-weight: bold;
    padding-top:10px
  }
  .choose .biaoti .aaa span{
    background:#007aff;
    font-size:12px !important;
    color:#fff;
    border-radius:14px;
    font-weight:normal;
    margin-right:10px;
    padding:2px 8px;
    position:relative;
    top:-2px
  }
  .choose .biaoti .price{
    font-weight: bold;
    display: inline-block;
    color:#f00
  }



  .choose .biaoti  .price i{
    color: #FF6600;
    font-style:normal;
    font-size:18px;
    font-weight:bold;
    padding:0 4px;
  }
  .choose .biaoti  .price b{
    font-size:12px;
  }

  .choose .biaoti .yjPrice{
    color: #727272;
    font-size: 14px;
    text-decoration:line-through;
    display: inline-block;
    padding-left: 5px;
  }
  .choose .biaoti .breif{
    font-size:15px;
    line-height:22px;
    letter-spacing:1px;
    padding-top:10px;
    color:#666
  }

  .choose .biaoti2{
    display: block;
    font-size: 14px;
    color: #000;
    background: #fff;
    padding: 15px 4%;
    position: relative;
  }
  .choose .biaoti2:after{
    position: absolute;
    content:'';
    bottom:0;
    width:92%;
    height:1px;
    background:#f6f6f6;
    left:50%;
    transform: translateX(-50%);
  }
  .choose .mscon{
    display: block;
    font-size: 14px;
    color: #666;
    line-height: 24px;
    margin: 0 auto;
    padding: 30rpx 0;
    background: #fff;
    padding:10px 10px 70px 10px;
    background: #FFFFFF;
    box-shadow: 0px 0px 10px 0px rgba(47, 120, 255, 0.2);
    border-radius: 10px;
    margin-top:15px
  }
  .choose .mscon span{
    display: block;
    width: 92%;
    margin: 0 auto;
    padding: 15px 0;
  }
  .mscon img{
    display: block;
    width: 100%;
  }
  

  .footer1{
    height: 50px;
    background: #fff;
    width: 94%;
    box-shadow: 0px 0px 10px 0px rgba(47, 120, 255, 0.2);
    border-radius: 10px;
    position: fixed;
    bottom: 10px;
    left: 3%;
    z-index: 1
  }
  .storedetailApp .footer1 .foot-title{
    float: left;
    margin-left: 4%;
    height:50px;
    line-height:50px;
  }
  .storedetailApp .footer1 .foot-title span{
    font-size: 14px;
    color: #727272;
    margin-right:15px;
  }
  .storedetailApp .footer1 .foot-title span b{
    color: #FF6600;
    font-size:17px;
    font-weight:500;
  }

  .storedetailApp .footer1 .foot-title span i{
    color: #FF6600;
    font-size:12px;
    font-style:normal
  }

  .storedetailApp .footer1 .pay{
    float: right;
    color: #fff;
    margin-right: 4%;
    margin-top:5px;
    width:40%
  }
  .storedetailApp .footer1 .pay span{
    float:left;
    height:40px;
    line-height:40px;
    font-size: 14px;
    width:100%;
    text-align:center;
    font-weight:bold;
    background: #FF751A;
    border-radius:40px;
  }


  .storedetailApp .chooseUser{
    width:100%;
    display:block;
    margin:0 auto;
    background:#fff;
    box-shadow: 0px 0px 10px 0px rgba(47, 120, 255, 0.2);
    border-radius: 10px;
    padding:15px 0;
    position:relative;
  }
  .storedetailApp .chooseUser:after{
    display:block;clear:both;content:"";visibility:hidden;height:0
  }
  .storedetailApp .chooseUser .leftuser{
    float:left;
    width:80%;
    margin-left:15px;
  }
  .storedetailApp .chooseUser .leftuser p{
    color:#333;
    font-size:15px;
  }
  .storedetailApp .chooseUser .leftuser p.curt{
    padding-top:10px;
    color:#666
  }
  .storedetailApp .chooseUser img{
    width:8px;
    position:absolute;
    top:51%;
    transform: translateY(-50%);
    right:15px;
  }



  .storedetailApp #el-drawer__title span{
    text-align:center;
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: 600;
    color: #2F78FF;
  }

  .storedetailApp .el-drawer__wrapper ul{
    width:90%;
    margin:0 auto;
  }
  .storedetailApp .el-drawer__wrapper li{
    border-bottom:solid 1px #EBF2FF;
    padding:15px 0 10px 0;
    position:relative;
  }
  .storedetailApp .el-drawer__wrapper li:last-child{
    border-bottom:none;
  }

  .storedetailApp .el-drawer__wrapper li p{
    padding-bottom:10px;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #333333;
    padding-left:45px;
  }
  .storedetailApp .el-drawer__wrapper li p:last-child{
    color: #666;
  }

  .storedetailApp .el-drawer__wrapper li a{
    position:absolute;
    left:0;
    top:50%;
    transform: translateY(-50%);
    color: #2F78FF;
    font-size:18px;
  }
  .storedetailApp .el-drawer__wrapper li a img{
    display:block;
    width:30px;
  }

  .storedetailApp .el-drawer__wrapper .append{
    background:#2F78FF;
    color:#fff;
    position:absolute;
    right:20px;
    top:25%;
    font-size:14px;
    padding:5px 10px;
    border-radius: 10px
  }
</style>